import { Card } from "antd";
import { useTranslation } from "react-i18next";

import ImportContext from "./ImportContext";
import UploadForm from "./UploadForm";

const UpdateCard = ({ model, modelName }) => {
  const { t } = useTranslation();

  const title = t("importTool:import.updateForm.title", { model: modelName });

  return (
    <ImportContext.Provider value={{ model, modelName, operation: "update" }}>
      <Card title={title}>
        <UploadForm />
      </Card>
    </ImportContext.Provider>
  );
};

export default UpdateCard;
